import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-demo-responsive-table',
  templateUrl: './demo-responsive-table.component.html',
  styleUrls: ['./demo-responsive-table.component.scss']
})
export class DemoResponsiveTableComponent implements OnInit {

  constructor() { }
  ngOnInit() {}
  isTrue
  
}
